import { DeepWritable } from 'ts-essentials'

export function deepCopy<T>(object: T): DeepWritable<T> {
  return JSON.parse(JSON.stringify(object))
}
